import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import {
  CancelWarningExely,
  KyrgyzstanEmpty,
  KyrgyzstanLoader,
} from 'entities/kyrgyzstan'

import { RealtySource } from 'shared/api/kyrgyzstan/search/model'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import { CancelBookingAction } from './ui/cancel-booking-action'
import { CancelWarningBlock } from './ui/cancel-warning-block'
import { ListBlock } from './ui/list-block'

import { useCancelBookingPage } from './lib'
import s from './styles.module.scss'

const KyrgyzstanCancelBookingPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const {
    order,
    realtyData,
    cancellationPenalty,
    isLoading,
    errorCancellationPenalty,
    warningConfig,
    bookingDetails,
    paymentDetails,
    handleCancel,
    isCheckinWithin24h,
    errorDecline,
    isLoadingDecline,
  } = useCancelBookingPage()

  const handleGoBack = () => {
    navigate(-1)
  }

  const header = (
    <HeaderGoBack
      title={t('kyrgyzstan_block.cancel_booking.title')}
      onGoBack={handleGoBack}
      variant="white"
      arrowColor="var(--inverse)"
      buttonWhite
    />
  )

  if (isLoading) {
    return (
      <div className={s.container}>
        {header}
        <KyrgyzstanLoader />
      </div>
    )
  }

  if (!order || !realtyData) {
    return (
      <div className={s.container}>
        {header}
        <KyrgyzstanEmpty title={t('kyrgyzstan_block.error.title')} />
      </div>
    )
  }

  if (errorCancellationPenalty || !cancellationPenalty) {
    return (
      <div className={s.container}>
        {header}
        <KyrgyzstanEmpty
          title={errorCancellationPenalty || t('kyrgyzstan_block.error.title')}
        />
      </div>
    )
  }

  return (
    <div className={s.container}>
      {header}

      <div className={clsx('container', s.warningContainer)}>
        {realtyData.source === RealtySource.EXELY ? (
          <CancelWarningExely
            cancellationPolicy={order.cancellation_policy}
            penaltyAmount={String(cancellationPenalty.penalty_amount)}
            currencyCode={cancellationPenalty.currency_code}
          />
        ) : (
          <CancelWarningBlock
            type={warningConfig.type}
            title={warningConfig.title}
            description={warningConfig.description}
          />
        )}
      </div>

      <div className={s.content}>
        <ListBlock list={bookingDetails} />

        <ListBlock list={paymentDetails} />

        {errorDecline && (
          <p className={clsx('semi-bold-14', s.errorText)}>{errorDecline}</p>
        )}
      </div>

      {cancellationPenalty.can_cancel && (
        <div className={s.emptyWrapper}>
          <CancelBookingAction
            onCancel={handleCancel}
            isLoading={isLoadingDecline}
            isCheckinWithin24h={isCheckinWithin24h}
            paymentStatus={order.payment_status}
          />
        </div>
      )}
    </div>
  )
}

export default observer(KyrgyzstanCancelBookingPage)
